import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import React from 'react'
import { useLoaderData } from 'react-router-dom'
import PortalPage from '../pages/PortalPage'
import ConstrainedCopy from '../shared/ConstrainedCopy'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalPrivacyModule = () => {
  const data = useLoaderData()
  const {
    page: { content },
  } = data

  return (
    <PortalPage data={data} shouldOffsetContent showHeader hidePrimaryNav>
      <CopyRenderer
        htmlAst={content.copy.body}
        CopyComponent={ConstrainedCopy}
      />
    </PortalPage>
  )
}

export default PortalPrivacyModule
